"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Icons_1 = require("../Icons");
var ToastCountdown_1 = __importDefault(require("../Toast/ToastCountdown"));
var iconsByAppearance = {
    error: Icons_1.FlameIcon,
    info: Icons_1.InfoIcon,
    success: Icons_1.CheckIcon,
    warning: Icons_1.AlertIcon
};
var Icon = function (_a) {
    var appearance = _a.appearance, autoDismiss = _a.autoDismiss, autoDismissTimeout = _a.autoDismissTimeout, isRunning = _a.isRunning;
    var Glyph = iconsByAppearance[appearance];
    return (react_1["default"].createElement("div", { className: "react-toast-notifications__toast__icon-wrapper react-toast-notifications__toast__icon-wrapper--" + appearance },
        react_1["default"].createElement(ToastCountdown_1["default"], { opacity: autoDismiss ? 1 : 0, autoDismissTimeout: autoDismissTimeout, isRunning: isRunning }),
        react_1["default"].createElement(Glyph, { className: "react-toast-notifications__toast__icon" })));
};
exports["default"] = Icon;
